export default __webpack_public_path__ + "static/media/SAL2.af98dab4.jpg";